import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  AgentCollectionPercentageRequest,
  AgentCollectionPercentageResponseData,
  AgentVisitPercentageRequest,
  AgentVisitPercentageResponseData,
  AgentWiseSummaryRequest,
  AgentWiseSummaryResponseData,
  DayWiseVisitRequest,
  DayWiseVisitResponseData,
  FieldSupervisorVisitSummaryState,
} from 'redux/types/FieldSupervisorVisitSummary.types';

export const fieldSupervisorVisitSummaryInitialState: FieldSupervisorVisitSummaryState =
  {
    agentWiseSummary: null,
    loading: false,
    error: null,
    dayWiseVisit: null,
    agentVisitPercentage: null,
    agentCollectionPercentage: null,
  };

const fieldSupervisorVisitSummarySlice = createSlice({
  name: 'fieldSupervisorVisitSummary',
  initialState: fieldSupervisorVisitSummaryInitialState,
  reducers: {
    fetchAgentWiseSummary: (
      state,
      action: PayloadAction<AgentWiseSummaryRequest>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgentWiseSummarySuccess: (
      state,
      action: PayloadAction<AgentWiseSummaryResponseData>
    ) => {
      state.loading = false;
      state.agentWiseSummary = action.payload;
      state.error = null;
    },
    fetchAgentWiseSummaryFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDayWiseVisit: (state, action: PayloadAction<DayWiseVisitRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchDayWiseVisitSuccess: (
      state,
      action: PayloadAction<DayWiseVisitResponseData>
    ) => {
      state.loading = false;
      state.dayWiseVisit = action.payload;
      state.error = null;
    },
    fetchDayWiseVisitFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchAgentVisitPercentage: (
      state,
      action: PayloadAction<AgentVisitPercentageRequest>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgentVisitPercentageSuccess: (
      state,
      action: PayloadAction<AgentVisitPercentageResponseData>
    ) => {
      state.loading = false;
      state.agentVisitPercentage = action.payload;
      state.error = null;
    },
    fetchAgentVisitPercentageFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchAgentCollectionPercentage: (
      state,
      action: PayloadAction<AgentCollectionPercentageRequest>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgentCollectionPercentageSuccess: (
      state,
      action: PayloadAction<AgentCollectionPercentageResponseData>
    ) => {
      state.loading = false;
      state.agentCollectionPercentage = action.payload;
      state.error = null;
    },
    fetchAgentCollectionPercentageFailure: (
      state,
      action: PayloadAction<any>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetAgentWiseSummary: (state) => {
      state.agentWiseSummary = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchAgentWiseSummary,
  fetchAgentWiseSummarySuccess,
  fetchAgentWiseSummaryFailure,
  resetAgentWiseSummary,
  fetchDayWiseVisit,
  fetchDayWiseVisitSuccess,
  fetchDayWiseVisitFailure,
  fetchAgentVisitPercentage,
  fetchAgentVisitPercentageSuccess,
  fetchAgentVisitPercentageFailure,
  fetchAgentCollectionPercentage,
  fetchAgentCollectionPercentageSuccess,
  fetchAgentCollectionPercentageFailure,
} = fieldSupervisorVisitSummarySlice.actions;

export default fieldSupervisorVisitSummarySlice.reducer;
